import _classCallCheck from "/home/docb/git/randomsplinewaves/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/docb/git/randomsplinewaves/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/docb/git/randomsplinewaves/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/docb/git/randomsplinewaves/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/docb/git/randomsplinewaves/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Util } from './Util.js';
import { Container } from './Container.js';
import { _registerNode } from './Global.js';
export var Group = /*#__PURE__*/function (_Container) {
  _inherits(Group, _Container);

  var _super = _createSuper(Group);

  function Group() {
    _classCallCheck(this, Group);

    return _super.apply(this, arguments);
  }

  _createClass(Group, [{
    key: "_validateAdd",
    value: function _validateAdd(child) {
      var type = child.getType();

      if (type !== 'Group' && type !== 'Shape') {
        Util.throw('You may only add groups and shapes to groups.');
      }
    }
  }]);

  return Group;
}(Container);
Group.prototype.nodeType = 'Group';

_registerNode(Group);